// extracted by mini-css-extract-plugin
export default {"activityLink":"ActivityLink_activityLink__GLt6T","activityIdentifier":"ActivityLink_activityIdentifier__lwRAU"};